import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import {ReactComponent as ExpandPlusIcon} from '../../assets/img/expand-plus.svg';
import {ReactComponent as ExpandMinusIcon} from '../../assets/img/expand-minus.svg';


export default function CustomAccordion({ summary, details, panel, expanded, handleChange }) {
  const theme = useTheme();

  return (
    <Accordion expanded={expanded === panel} disableGutters elevation={0} onChange={() => handleChange(panel)} sx={{ borderBottom: `1px dashed ${theme.palette.mode === 'light' ? '#e4e6ef' : '#323248'}` }}>
      <AccordionSummary
        expandIcon={expanded === panel ?
          <Box sx={{ display: 'inline-flex', color: '#009ef7' }}><ExpandMinusIcon /></Box> :
          <Box sx={{ display: 'inline-flex', color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674', '&:hover': { color: '#009ef7' } }}><ExpandPlusIcon /></Box>
        }
        sx={{
          flexDirection: 'row-reverse',
          minHeight: '32px',
          p: 0,
          '& .MuiAccordionSummary-content': {
            marginLeft: 2,
          }
        }}
      >
        <Typography sx={{ fontSize: '14px', fontWeight: '600', color: theme.palette.mode === 'light' ? '#5e6278' : '#92929f' }}>{summary}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Typography sx={{ fontSize: '13px', fontWeight: '400', mt: 1, ml: 3, color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>
          <span dangerouslySetInnerHTML={{__html: details}} />
        </Typography>
      </AccordionDetails>
    </Accordion>
  )
}
